/**
 * WebMCP 工具入口
 * 注册所有游戏操作工具
 */
/* eslint-disable */
var moveTool = require('./move');
var rotateTool = require('./rotate');
var hardDropTool = require('./hardDrop');
var executeSequenceTool = require('./executeSequence');
var gameControl = require('./gameControl');
var configureTool = require('./configure');
var gameState = require('../resources/gameState');
var sayTool = require('./say');
var runAutoplay = require('./runAutoplay');
var getRandomTool = require('./getRandom');

// 导出所有工具
var tools = [
  moveTool,
  rotateTool,
  hardDropTool,
  executeSequenceTool,
  gameControl.startTool,
  gameControl.pauseTool,
  gameControl.restartTool,
  configureTool,
  gameState.stateTool,
  sayTool,
  runAutoplay.runAutoplayTool,
  runAutoplay.getAutoplayResultTool,
  runAutoplay.waitForAutoplayTool,
  getRandomTool,
];

// 工具映射表
var toolMap = {};
for (var i = 0; i < tools.length; i++) {
  toolMap[tools[i].name] = tools[i];
}

module.exports = {
  tools: tools,
  toolMap: toolMap,
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/index.js